export const JOURNAL_REPORT = `api/v1/reports/journal`;

export const JOURNAL_REPORT_XML = `api/v1/journals/export`;

export const JOURNAL_REPORT_EXCEL = `api/v1/reports/journal/excel`;
